import {Line} from "vue-chartjs";

export default {
    extends: Line,
    props: ["data", "options"],
    mounted() {
        this.addPlugin({
            id: 'my-plugin',
            afterDatasetsDraw: function (chart) {
                let chart_type = chart.config.type;

                if (chart.tooltip._active && chart.tooltip._active.length && chart_type === 'line') {
                    let activePoint = chart.tooltip._active[0],
                        ctx = chart.chart.ctx,
                        x_axis = chart.scales['x-axis-0'],
                        y_axis = chart.scales['y-axis-0'],
                        x = activePoint.tooltipPosition().x,
                        topY = y_axis.top,
                        bottomY = y_axis.bottom;

                    ctx.save();
                    ctx.beginPath();
                    ctx.moveTo(x, topY + 7);
                    ctx.lineTo(x, bottomY + 1);
                    ctx.lineWidth = 1;
                    ctx.strokeStyle = 'rgba(0, 0, 0, 0.12)';
                    ctx.stroke();
                    ctx.restore();
                }
            }
        })

        // this.renderChart(this.data, this.options);
        this.renderLineChart();
    },
    computed: {
        chartData: function () {
            return this.data;
        },
        chartOptions: function () {
            return this.options;
        }
    },
    methods: {
        renderLineChart: function () {
            this.renderChart(this.chartData, this.chartOptions);
        }
    },
    watch: {
        data: function () {
            this.renderLineChart();
        }
    }
};
